import type { DashboardFilter } from './DashboardFilter';

export const shouldDisableClickThrough = (
  filters: DashboardFilter
): boolean => {
  // Registers use "AND" filtering on departments and tags, whilst the dashboard used "OR" filtering.
  // To avoid the mismatch, disable click through when more then 1 department or tag is selected.
  return filters.departments.length > 1 || filters.tags.length > 1;
};
